import { useAtom } from 'jotai'
import { googleCredentialAtom } from 'store/atoms'
import { useEffect } from 'react'
import axios from 'axios'
import { googleLogout } from '@react-oauth/google'
import { RESET } from 'jotai/utils'

const useAxiosInterceptorsResponse = () => {
  const [_, setGoogleCredential] = useAtom(googleCredentialAtom)

  useEffect(() => {
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          googleLogout()
          setGoogleCredential(RESET)
          return Promise.reject(error)
        }

        return Promise.reject(error)
      }
    )
  }, [])
}

export { useAxiosInterceptorsResponse }
